import * as React from 'react';
import { Button, Dialog, DialogTitle, styled } from '@mui/material';
import { useState } from 'react';
import Instructions from './Instructions';
import styles from './Instructions.module.scss'

// Dialog Box styling
const InstructionsDialogStyle = styled(Dialog)(({theme}) => ({
    "& .MuiDialog-paper": {
        minWidth: '90%',
        minHeight: 'fit-content',
        height: 'inherit',
        top: '-5%',
      },
    "& .MuiDialog-container": {
        alignItems: 'flex-start',
        marginTop: theme.spacing(5),
      },
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        alignItems: 'flex-start',
        textAlign: 'center',
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
      }
}));

interface InstructionsDialogProps {
    onClose: () => void;
    open: boolean;
    children: React.ReactNode;
};

const InstructionsDialog = (props: InstructionsDialogProps): JSX.Element => {
    const { children, onClose, ...other} = props;
    return (
        <DialogTitle {...other}>
            {children}
        </DialogTitle>
    );
};

const InstructionsButton = (): JSX.Element => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = ():void => {
        setOpen(true);
    };

    const handleClose = ():void => {
        setOpen(false);
    };

    return (
        // Flexgrow forces 'Export' and all subsequent components on the navbar over to the right
        <div>
            <Button onClick={handleClickOpen} className={styles.instructionsButton}>
                Instructions
            </Button>
            <InstructionsDialogStyle onClose={handleClose} open={open}>
                <InstructionsDialog onClose={handleClose} open={open}>
                    <Instructions />
                </InstructionsDialog>
            </InstructionsDialogStyle>
        </div>
    );
};

export default InstructionsButton;